function toPercentage(ratio, decimals = 2) {
  return `${(ratio * 100).toFixed(decimals)}%`;
}

export default toPercentage;
